import React, { useRef, useState } from 'react';
import { APIEndpoint } from "../../../utils/axios";
import { DataGrid, UploadModal, UploadButton } from "../../../common";
import { onDownloadXlsFile } from '../../../utils/commonFunctions';
import { useTranslation } from 'react-i18next';

const Columns = [
  { field: 'aircraftNumber', filter: true, checkboxSelection: true, minWidth: 130 },
  { field: 'name', filter: true, minWidth: 160 },
  { field: 'typeCode', filter: true, minWidth: 130 },
];

export const AircraftsPage = (props) => {
  const { t ,ready} = useTranslation();
  const [searchKey] = useState('');
  const [showUpload, setShowUpload] = useState(false);
  const tableRef = useRef();

  const filterData = {
    action: 4,
    collection: '',
    filterOperation: 'or',
    filters: [],
    limit: 50,
    page: 1,
    searchParam: ''
  };
  const fetchAirtcrafts = async (page = 1, perPage = 50) => {
    filterData.page = page;
    filterData.limit = perPage;
    filterData.searchParam = searchKey;
    const res = await APIEndpoint.post('aircrafts/process', filterData);
    return res;
  }

  // const onSearch = (e) => {
  //   setSearchKey(e.target.value);
  // };

  const onDownloadSampleFile = () => {
    onDownloadXlsFile('samples/downloads/Aircrafts_Upload_Sample', 'Aircrafts_Upload_Sample')
  }
  const handleUploadAircraft = (e) => {
    const formData = new FormData()
    formData.append('file', e.target.files[0]);
    return APIEndpoint.post('aircrafts/upload', formData, { 'Content-Type': "multipart/form-data" })
  }
  return (
    <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">
      {
        <>
          <div className="flexRow justifyContentFlexEnd alignItemsCenter margRight margBot10">
            <UploadButton
              onClick={() => setShowUpload(true)}
              label={t('pages.pagesContent.aircrafts.uploadButtonTitle')} />
          </div>

          <DataGrid
            ref={tableRef}
            className='full-flex'
            columns={[...Columns]}
            initialPageLimit={50}
            showDefaultFilters={false}
            searchKey={searchKey}
            // setSearchKey={(e) => onSearch(e)}
            actions={[]}
            columnResize={true}
            getRows={fetchAirtcrafts}
          />
        </>
      }
      {
        showUpload &&
        <UploadModal
          uploadAPI={handleUploadAircraft}
          modelTitle={t('pages.pagesContent.aircrafts.uploadButtonTitle')}
          onUploadClose={() => setShowUpload(false)}
          onDownloadSampleFile={onDownloadSampleFile}
        />
      }
       {
               !ready &&<div className='overlay_hide sub'></div>
                }
    </div>
  )
}